export default {
  isLoggedIn: state => state.isLoggedIn,
  userToken: state => state.userToken,
  userDetails: state => state.userDetails,
  userActiveBranch: state => state.userActiveBranch
}
